import classNames from 'classnames';
import React, { Ref } from 'react';

import { Input } from '@eika/input';

import { FocusableHtmlElement } from '../hooks';

import './kontaktinfo.scss';

interface Props {
    name: string;
    value: string;
    label: string;
    subLabel?: string;
    placeholder?: string;
    type?: string;
    autocomplete?: string;
    numericKeyboard?: boolean;
    onChange: (value: string) => void;
    errorText: string;
    isValid: boolean;
    small?: boolean;
    itemRef?: Ref<FocusableHtmlElement>;
}

export const KontaktinfoInput: React.FC<Props> = ({
    name,
    value,
    label,
    placeholder = '',
    type = 'text',
    autocomplete,
    numericKeyboard = false,
    errorText,
    isValid,
    onChange,
    small = false,
    itemRef,
    subLabel,
}) => (
    <div className="kontaktinfo-input-wrapper">
        <Input
            id={`kontaktinfo-${name}`}
            type={type}
            autoComplete={autocomplete}
            inputMode={numericKeyboard ? 'numeric' : undefined}
            className={classNames({ 'kontaktinfo-input__small': small })}
            value={value}
            label={label}
            sublabel={subLabel}
            onChange={(event) => onChange(event.currentTarget.value)}
            ref={itemRef as Ref<HTMLInputElement>}
            error={!isValid && errorText}
            placeholder={placeholder}
        />
    </div>
);
